import { Box, styled, Typography } from "@mui/material";

export const StackablePanel = styled(Box)(({ theme }) => ({
  position: "absolute",
  inset: 0,
  padding: theme.spacing(1),
  backgroundColor: theme.palette.common.white,
  overflowY: "auto",
}));

export const StackablePanelHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  height: 40,
  borderRadius: theme.shape.borderRadius,
  background: "#f5f5f5",
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  marginBottom: theme.spacing(2),
}));

export const StackablePanelHeaderTitle = styled(Typography)`
  font-weight: 700;
  color: #e1373b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
